module.exports = __webpack_public_path__ + "img/3.c74de4d.png";